// extracted by mini-css-extract-plugin
export default {"fullpageContainer":"Map_fullpageContainer__tjHK-"};